import { render, staticRenderFns } from "./Completion.vue?vue&type=template&id=0dd4b48a&scoped=true&"
import script from "./Completion.vue?vue&type=script&lang=ts&"
export * from "./Completion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4b48a",
  null
  
)

export default component.exports